var v1="<div class=\"form-group\"> <div class=\"input-group\"> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.onClick()\">Test Ftp Connection</button> <label id=\"errorMessage\">{{vm.errorMessage}}</label> </div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTestFtpConnection.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaTestFtpConnection/lbaTestFtpConnection.html
// module id = 400
// module chunks = 0